import TeamCta from "./TeamCtaGrid";

const TeamCtaGridWithProps = ({ blok }: { blok: any }) => {
  return <TeamCta title={blok.title} description={blok.description} ctas={blok.ctas} avatars={blok.avatars} />;
};

export default TeamCtaGridWithProps;
